<template>
  <div
    class="bg-white rounded-lg overflow-hidden shadow ring-1 ring-black ring-opacity-5"
    :class="[cardStyle]"
  >
    <div class="flex flex-row items-center justify-between p-4">
      <h1 class="text-lg">{{ title }}</h1>
      <span
        class="px-3 py-1 bg-gray-100 text-gray-500 rounded-full uppercase text-xs"
        v-if="descriptor"
        >{{ descriptor }}</span
      >
    </div>
    <div class="relative" :class="[innerHeight]">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "Card Title"
    },
    descriptor: {
      type: String,
      default: null
    },
    innerHeight: {
      type: String,
      default: "h-40"
    },
    cardStyle: {
      type: String,
      default: null
    }
  }
};
</script>
